export const X_Y_AXIS_STYLE = {
  fontSize: '0.75rem',
  fontWeight: '400',
  lineHeight: '1rem',
  color: '#0E1212',
};

export const SKELETON_COLOR = '#C1CFD6';
